/* eslint-disable react/destructuring-assignment */
import React from 'react';
import Section from '../atoms/Section';
import { SectionProps } from './types';
import { getSectionWrapperProps, importSectionComponents } from './utils';

const sectionComponents = importSectionComponents();

const Sections: React.VFC<SectionProps> = ({ sections }) => {
  if (!sections) {
    return null;
  }

  return (
    <>
      {sections.map((section) => {
        const { _key, _type } = section ?? {};
        if (!_key) {
          throw new Error(
            `"_key" field is missing in section type "${_type}". Did you forget to query it?`
          );
        }

        if (!_type) {
          throw new Error(
            `"_type" field is missing in section with key "${_key}". Did you forget to query it?`
          );
        }

        const { component: Component, meta } = sectionComponents[_type] || {};

        if (!Component) {
          // eslint-disable-next-line no-console
          console.warn(`Section component not found for type "${_type}".`);

          return null;
        }

        const sectionWrapperProps = getSectionWrapperProps(
          section,
          meta.defaultSectionWrapperProps
        );

        return (
          <Section key={_key} {...sectionWrapperProps}>
            <Component {...section} />
          </Section>
        );
      })}
    </>
  );
};

export default Sections;
